<div *ngIf="!isAdd" (click)='collapse()' [ngStyle]="{'cursor': !isEditable?'pointer':''}">
    <div class='col-sm-1'>{{vendor.id}}</div>
    <div class='col-sm-11'>
        <div class="pull-right" *ngIf="!isEditable">
            <div class='inline' style='margin-left:0.5em;' *ngIf="courseVendor.zoom.status">
                <app-open-button-sm (click)="openZoom()">Zoom</app-open-button-sm>
            </div>
            <div class='inline' style='margin-left:0.5em;' *ngIf="courseVendor.docebo.status">
                <app-open-button-sm (click)="openDocebo()">Docebo</app-open-button-sm>
            </div>
            <div class='inline' style='margin-left:0.5em;' *ngIf="courseVendor.joinUrl">
                <app-open-button-sm (click)="open(courseVendor.joinUrl)">Join</app-open-button-sm>
            </div>
        </div>
        {{vendor.name}}
        <span *ngIf="courseVendor.status !== 'Active'" style='font-style: italic;'> - {{courseVendor.status}}</span>
        <!-- 
        <div style='font-size:0.9em;margin-top:0.25em;'>
            <div>details</div>
        </div>
        -->
    </div>
</div>

<div class='row' *ngIf='loadingMsg'>
    <div class='col-sm-12 text-center' style='padding:1.0em 0'>
        <div>{{loadingMsg}}</div>
    </div>
</div>

<div class="row" [ngClass]="{'hide':!display}">

    <app-loading [isLoading]="isLoading" *ngIf="isLoading"></app-loading>

    <div class="col-sm-12" style='padding-bottom:0.5em;' *ngIf='isLoaded' [ngStyle]="{'margin-top': !isAdd ? '2.0em' : '0'}">
        <form [formGroup]="form" (ngSubmit)="save()" novalidate>

            <div class="col-sm-12 instructions">
                <div class='pull-right action-menu-sm'>
                    <app-button-status *ngIf="isSaving || isDeleting"></app-button-status>
                    <app-edit-button-sm (click)='edit()' *ngIf="!isEditable"></app-edit-button-sm>
                    <app-delete-button-sm (click)='delete()' *ngIf="!isEditable"></app-delete-button-sm>
                    <app-save-button-sm (click)='save()' *ngIf="isEditable"></app-save-button-sm>
                    <app-cancel-button-sm (click)='cancel()' *ngIf="isEditable"></app-cancel-button-sm>
                </div>
                <div *ngIf="!isAdd">Below are details specific to this Vendor.</div>
                <div *ngIf="isAdd">Complete the form below to create a Vendor.</div>
            </div>
            
            <div class='col-sm-12 text-center error' *ngIf='errorMessage'>
                {{errorMessage}}
            </div>

            <div class="col-sm-12">
                <label>
                    Name *
                    <span *ngIf="name.invalid && (name.dirty || name.touched || isSubmitted)" class="error">
                        <span *ngIf="name.errors.required">- Required</span>
                        <span *ngIf="name.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.name ) ? vendor.name : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="name" formControlName="name" placeholder="Name" required class="form-control" maxlength="300">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Status *
                    <span *ngIf="status.invalid && (status.dirty || status.touched || isSubmitted)" class="error">
                        <span *ngIf="status.errors.required">- Required</span>
                        <span *ngIf="status.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( courseVendor.status ) ? courseVendor.status : "-" }}</div>
                <div *ngIf="isEditable">
                    <div *ngIf="isEditable">
                        <ng-select id="status" formControlName="status" [items]="statuses" bindValue="value" bindLabel="name" placeholder="Select Status" [clearable]="false" [searchable]="false"></ng-select>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <label>Sort Order</label>
                <div *ngIf="!isEditable">{{ ( courseVendor.sortOrder !== null ) ? courseVendor.sortOrder : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="sortOrder" formControlName="sortOrder" class="form-control" type="number" min="0" placeholder="Sort Order">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Description
                    <span *ngIf="isEditable && description.invalid && (description.dirty || description.touched || isSubmitted)" class="error">
                        <span *ngIf="description.errors.maxlength">- Too long</span>
                    </span>
                    <div class='details' *ngIf="isEditable">Maxlength: 4,000 characters</div>
                </label>
                <div *ngIf="!isEditable">{{ vendor.description ? vendor.description : "-" }}</div>
                <div *ngIf="isEditable">
                    <textarea id="description" formControlName="description" placeholder="Description" rows="10" class="form-control" maxlength="4000"></textarea>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="group-title" style='margin-top:2.0em;'>Contact</div>
            </div>

            <div class="col-sm-12">
                <label>
                    Address
                    <span *ngIf="address.invalid && (address.dirty || address.touched || isSubmitted)" class="error">
                        <span *ngIf="address.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.address ) ? vendor.address : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="address" formControlName="address" placeholder="Address" class="form-control" maxlength="100">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    City
                    <span *ngIf="city.invalid && (city.dirty || city.touched || isSubmitted)" class="error">
                        <span *ngIf="city.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.city ) ? vendor.city : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="city" formControlName="city" placeholder="City" class="form-control" maxlength="100">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    State
                    <span *ngIf="state.invalid && (state.dirty || state.touched || isSubmitted)" class="error">
                        <span *ngIf="state.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.state ) ? vendor.state : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="state" formControlName="state" placeholder="State" class="form-control" maxlength="10">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Zip
                    <span *ngIf="zip.invalid && (zip.dirty || zip.touched || isSubmitted)" class="error">
                        <span *ngIf="zip.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.zip ) ? vendor.zip : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="zip" formControlName="zip" placeholder="Zip" class="form-control" maxlength="10">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Email
                    <span *ngIf="email.invalid && (email.dirty || email.touched || isSubmitted)" class="error">
                        <span *ngIf="email.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.email ) ? vendor.email : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="email" formControlName="email" placeholder="Email" class="form-control" maxlength="100">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Phone
                    <span *ngIf="phone.invalid && (phone.dirty || phone.touched || isSubmitted)" class="error">
                        <span *ngIf="phone.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.phone ) ? vendor.phone : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="phone" formControlName="phone" placeholder="Phone" class="form-control" maxlength="10" type="number">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Website
                </label>
                <div *ngIf="!isEditable">
                    <span *ngIf="vendor.website">
                        <a [attr.href]="vendor.website" target="_blank">{{vendor.website}}</a>
                    </span>
                    <span *ngIf="!vendor.website">-</span>
                </div>
                <div *ngIf="isEditable">
                    <input id="website" formControlName="website" placeholder="Website URL" class="form-control" maxlength="255">
                </div>
            </div>

            <div class="col-sm-12">
                <label>Logo</label>
                <div *ngIf="!isEditable">
                    <span *ngIf="!vendor.logo">-</span>
                    <span *ngIf="vendor.logo">
                        <img class="file-preview" [src]="vendor.logo">
                    </span>
                </div>
                <div *ngIf="isEditable">
                    <app-file-upload [image]="vendor.logo"></app-file-upload>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="group-title" style='margin-top:2.0em;'>Social</div>
            </div>

            <div class="col-sm-12">
                <label>
                    Facebook
                    <span *ngIf="facebook.invalid && (facebook.dirty || facebook.touched || isSubmitted)" class="error">
                        <span *ngIf="facebook.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.facebook ) ? vendor.facebook : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="facebook" formControlName="facebook" placeholder="Facebook" class="form-control" maxlength="100">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Twitter
                    <span *ngIf="twitter.invalid && (twitter.dirty || twitter.touched || isSubmitted)" class="error">
                        <span *ngIf="twitter.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.twitter ) ? vendor.twitter : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="twitter" formControlName="twitter" placeholder="Twitter" class="form-control" maxlength="100">
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    YouTube
                    <span *ngIf="youtube.invalid && (youtube.dirty || youtube.touched || isSubmitted)" class="error">
                        <span *ngIf="youtube.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( vendor.youtube ) ? vendor.youtube : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="youtube" formControlName="youtube" placeholder="YouTube" class="form-control" maxlength="100">
                </div>
            </div>
        <!-- 
            <div class="groupTitle">Representatives</div>

            <div>
                <label>Name</label>
                <div *ngIf="!isEditable">{{ ( vendor.representative_name ) ? vendor.representative_name : "-" }}</div>
                <div *ngIf="isEditable">
                    <input class="form-control" [(ngModel)]='editData.representative_name' type="text"
                        placeholder="Representative Name" name="representative_name">
                </div>
            </div>

            <div>
                <label>Photo</label>
                <div *ngIf="!isEditable">{{ ( vendor.representative_photo ) ? vendor.representative_photo : "-" }}</div>
                <div *ngIf="isEditable">
                    <input class="form-control" type="file" placeholder="Representative Photo" name="representative_photo">
                </div>
            </div>

            <div>
                <label>Email</label>
                <div *ngIf="!isEditable">{{ ( vendor.email ) ? vendor.email : "-" }}</div>
                <div *ngIf="isEditable">
                    <input class="form-control" [(ngModel)]='editData.email' type="text" placeholder="Email" name="email">
                </div>
            </div>

            <div>
                <label>Phone</label>
                <div *ngIf="!isEditable">{{ ( vendor.phone ) ? vendor.phone : "-" }}</div>
                <div *ngIf="isEditable">
                    <input class="form-control" [(ngModel)]='editData.phone' type="text" placeholder="Phone" name="phone">
                </div>
            </div>

            <div>
                <label>Description</label>
                <div *ngIf="!isEditable">
                    {{ ( vendor.representative_description ) ? vendor.representative_description : "-" }}</div>
                <div *ngIf="isEditable">
                    <input class="form-control" [(ngModel)]='editData.representative_description' type="text"
                        placeholder="Representative Description" name="representative_description">
                </div>
            </div>

            <div class="groupTitle">Handouts</div>

            <div>
                <label>Name</label>
                <div *ngIf="!isEditable">{{ ( vendor.handout_name ) ? vendor.handout_name : "-" }}</div>
                <div *ngIf="isEditable">
                    <input class="form-control" [(ngModel)]='editData.handout_name' type="text" placeholder="Handout" name="handout_name">
                </div>
            </div>
            
            <div>
                <label>Logo</label>
                <div *ngIf="!isEditable">{{ ( vendor.logo ) ? vendor.logo : "-" }}</div>
                <div *ngIf="isEditable">
                    <input class="form-control" type="file" placeholder="Logo" name="logo">
                </div>
            </div>

            <div>
                <label>File</label>
                <div *ngIf="!isEditable">{{ ( vendor.handout_name ) ? vendor.handout_name : "-" }}</div>
                <div *ngIf="isEditable">
                    <input class="form-control" type="file" placeholder="File" name="handout_file">
                </div>
            </div>

        -->

            <div class="col-sm-12">
                <div class='group-title' style='margin-top:2.0em;'>
                    Learning Management System Integrations
                </div>
            </div>
            
            <div class="col-sm-12">
                <label>
                    Docebo Integration
                </label>
                <div *ngIf="!isEditable">
                    <div class='pull-right' *ngIf="courseVendor.docebo.status">
                        <app-open-button-sm (click)="openDocebo()">Docebo</app-open-button-sm>
                    </div>
                    <div>{{courseVendor.docebo.status ? "Yes" : "-"}}</div>
                </div>
                <div *ngIf="isEditable">
                    <ng-select id="docebo" formControlName="docebo" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Docebo Integration" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div>

            <div class="col-sm-12" *ngIf="docebo.value">
                <label>
                    Show Open Button to Enrollees
                </label>
                <div *ngIf="!isEditable">
                    <div >
                        {{courseVendor.docebo.showOpen ? "Yes" : "No"}}
                    </div>
                </div>
                <div *ngIf="isEditable">
                    <ng-select id="doceboShowOpen" formControlName="doceboShowOpen" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Show Open Button" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div>

            <!-- 
            <div class="col-sm-12">
                <div class="group-title" style='margin-top:2.0em;'>Video Conference Integrations</div>
            </div>

            <div class="col-sm-12">
                <label>
                    Zoom Integration
                </label>
                <div *ngIf="!isEditable">
                    <div class='pull-right' *ngIf="courseVendor.zoom.status">
                        <app-open-button-sm (click)="openZoom()">Zoom</app-open-button-sm>
                    </div>
                    <div>{{courseVendor.zoom.status ? "Yes" : "No"}}</div>
                </div>
                <div *ngIf="isEditable">
                    <ng-select id="zoom" formControlName="zoom" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Zoom Integration" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div>

            <div class="col-sm-12" *ngIf="zoom.value">
                <label>
                    Show Open Button to Enrollees
                </label>
                <div *ngIf="!isEditable">
                    <div>
                        {{courseVendor.zoom.showOpen ? "Yes" : "No"}}
                    </div>
                </div>
                <div *ngIf="isEditable">
                    <ng-select id="zoomShowOpen" formControlName="zoomShowOpen" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Show Open Button" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div> 
            -->
            
            <div class="col-sm-12">
                <div class="group-title" style='margin-top:2.0em;'>Custom Join Link</div>
            </div>

            <div class="col-sm-12">
                <label>
                    URL
                    <span *ngIf="isEditable && joinUrl.invalid && (joinUrl.dirty || joinUrl.touched || isSubmitted)" class="error">
                        <span *ngIf="joinUrl.errors.maxlength">- Too long</span>
                    </span>
                    <div class='details' *ngIf="isEditable">Maxlength: 400 characters</div>
                </label>
                <div *ngIf="!isEditable">
                    <!-- <div class='pull-right' *ngIf="courseVendor.joinUrl">
                        <app-open-button-sm (click)="open(courseVendor.joinUrl)">Join</app-open-button-sm>
                    </div> -->
                    
                    <span *ngIf="courseVendor.joinUrl">
                        <a [attr.href]="courseVendor.joinUrl" target="_blank">{{courseVendor.joinUrl}}</a>
                    </span>
                    <span *ngIf="!courseVendor.joinUrl">-</span>
                </div>
                <div *ngIf="isEditable">
                    <input id="joinUrl" formControlName="joinUrl" class="form-control" placeholder="URL" maxlength='400'>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="group-title" style='margin-top:2.0em;'>Event Video</div>
            </div>

            <div class="col-sm-12">
                <label>
                    URL
                </label>
                <div *ngIf="!isEditable">
                    <span *ngIf="courseVendor.videoUrl">
                        <a [attr.href]="courseVendor.videoUrl" target="_blank">{{courseVendor.videoUrl}}</a>
                    </span>
                    <span *ngIf="!courseVendor.videoUrl">-</span>
                </div>
                <div *ngIf="isEditable">
                    <input id="videoUrl" formControlName="videoUrl" placeholder="Video URL" class="form-control" maxlength="400">
                </div>
            </div>

        </form>
        <!-- <div class="col-sm-12"><pre>{{courseVendor|json}}</pre></div> -->
    </div>
</div>